import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { AppConstants } from "../../shared/constants/constants";
import { AuthService } from "../../shared/services/auth.service";
import { AuthHelper } from "../../common/auth.helper";
import { DialogService } from "../../shared/services/dialog.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LoginModel } from "../../models/login/login.model";
import { BaseUrl } from '../../shared/urls/base.url';
import { BaseService } from "../../shared/services/base.service";
import { UserUrl } from "../../shared/urls/user.url";

@Component({
  selector: "app-landing",
  templateUrl: "./login.component.html",
})
export class LoginComponent implements OnInit {
  public isHiddenSpinner = true;
  public loginForm: FormGroup;
  public loginModel = new LoginModel();
  public forgetUrl: string;
  appConstants = AppConstants;
  navigateUrl: string = "/home";
  href: string;
  isShowSummaryError: boolean;

  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    public dialogService: DialogService,
    private baseService: BaseService,
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.activeRouter.paramMap.subscribe((params) => {
      this.loginModel.UserName = params.get("username");
    });
    this.isShowSummaryError = false;
    this.forgetUrl = `${BaseUrl.AUTH_URL}/account/ForgotPassword?returnurl=${BaseUrl.APP_URL}&mytmb=true`;
  }

  createForm() {
    this.loginForm = this.formBuilder.group({
      userName: ["", [Validators.required]],
      password: ["", [Validators.required]],
    });
  }

  showHidePasswordOnClick() {
    let $togglePassword = $('#togglePassword');
    let $password = $('#password');
    const type = $password.attr('type') === 'password' ? 'text' : 'password';
    $password.attr('type', type);
    $password.attr('data-type', type);

    // toggle the eye slash icon

    if (type == 'text') {
      $togglePassword.removeClass('fa-eye');
      $togglePassword.addClass('fa-eye-slash');
    }
    else {
      $togglePassword.addClass('fa-eye');
      $togglePassword.removeClass('fa-eye-slash');
    }

  }

  public onSubmit() {
    this.isShowSummaryError = false;
    if (this.loginForm.dirty && this.loginForm.valid) {

      const validateModel = {
        username: this.loginModel.UserName,
        password: this.loginModel.Password,
        returnUrl: BaseUrl.APP_URL
      };

      this.isHiddenSpinner = false;
      this.baseService.postData(UserUrl.VALIDATE_MYTMB, validateModel)
        .subscribe(
          (validateResponse) => {
            if (validateResponse) {

              const data = validateResponse.json();
              if (data && !data.errorMessage && !data.redirectURL) {
                this.isShowSummaryError = false;

                this.loginModel.UserName = data.username;

                this.authService
                  .login(this.loginModel)
                  .subscribe(
                    (result) => {
                      this.isHiddenSpinner = true;
                      this.router.navigate([this.navigateUrl]);
                    },
                    (error) => {
                      this.isShowSummaryError = true;
                      this.isHiddenSpinner = true;
                      AuthHelper.resetLocalStorage();
                    }
                  );
              }
              else {
                if (data.redirectURL) {
                  window.location.href = data.redirectURL;
                }

                this.isHiddenSpinner = true;
                this.isShowSummaryError = true;
              }
            }
          },
          error => {
            this.isHiddenSpinner = true;
          }
        );
    }
  }
}





// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/login/login.component.ts